import React, { useEffect, useState } from "react";
import './RegionSelectionModal.css';
import Modal from 'react-modal';
import RegionIcon from './images/region_icon.png';
import API from '../API';
import { useAuth0 } from "@auth0/auth0-react";

const RegionSelectionModal = ({callback}) => {
    const [showRegionSelectionModal, setShowRegionSelectionModal] = useState(true);
    const [regions, setRegions] = useState([]);
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();
    useEffect(() => {
        async function fetchData() {
            if (isAuthenticated) {
                const accessToken = await getAccessTokenSilently({
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "ffclient:play",
                });
                const response = await API.getAvailableServers(accessToken);
                if (response.status !== 200) {
                    console.log("Error getting available servers.");
                    return;
                }

                const data = await response.json();
                // Sort by id
                data.servers.sort((a,b) => a.id > b.id ? 1 : -1 );
                setRegions(data.servers);
            }
        }
        fetchData();
    }, [isAuthenticated, getAccessTokenSilently]);
    async function serverSelected(serverId) {
        if (isAuthenticated) {
            const accessToken = await getAccessTokenSilently({
                audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                scope: "ffclient:play",
            });
            const response = await API.joinServer(accessToken, { server_id: serverId });
            if (response.status !== 204) {
                console.log("Issue with joining server.");
            }
        }
        
        setShowRegionSelectionModal(false);
        callback();
    }
    return (
        <Modal
            isOpen={showRegionSelectionModal}
            parentSelector={()=> document.querySelector('.enter-world-container')}
            className="RegionSelectionModal__Content ff-modal-content-region"
            overlayClassName="RegionSelectionModal__Overlay"
            onRequestClose={() => setShowRegionSelectionModal(false)}
            shouldCloseOnOverlayClick={false}>
            <h2 className="connect-wallet-title">Select Server</h2>
            {/* <p className="connect-wallet-subtitle">Choose the nearest region for the best experience.</p> */}
            <ul className="wallet-name">
                { regions.map(region => 
                    <li key={region.id}><button className="wallet-add-button" disabled={region.count >= region.capacity} onClick={() => serverSelected(region.id)}><img src={RegionIcon} alt="Region icon" /><span>{region.name}</span><span className="server-numbers">{region.count}/{region.capacity}</span></button></li>
                )}
            </ul>
        </Modal>
    );
};

export default RegionSelectionModal;
